<template>
  <v-container class="admin-survey">
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_survey.title') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addSurveyModalShown = true">
          {{ $t('admin_survey.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <SurveyList full-height
                    :refresh-trigger.sync="refreshTrigger"
                    @edit="onSurveyEdit"></SurveyList>
      </v-col>
    </v-row>

    <AddSurveyModal :shown="addSurveyModalShown"
                    @cancel="addSurveyModalShown = false"
                    @finish="onAddSurveyModalFinish"></AddSurveyModal>

    <EditSurveyModal :shown="editSurveyModalShown"
                     :survey-id="editingSurveyId"
                     @cancel="editSurveyModalShown = false"
                     @finish="onEditSurveyModalFinish"></EditSurveyModal>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import SurveyList from "@/components/survey/SurveyList";
import AddSurveyModal from "@/components/survey/AddSurveyModal";
import EditSurveyModal from "@/components/survey/EditSurveyModal";

export default {
  name: 'Survey',
  components: {EditSurveyModal, AddSurveyModal, SurveyList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addSurveyModalShown = ref(false);
    const onAddSurveyModalFinish = function (item) {
      addSurveyModalShown.value = false;
      refresh();
      onSurveyEdit(item);
    }

    const editingSurveyId = ref(null);
    const editSurveyModalShown = ref(false);
    const onSurveyEdit = function (item) {
      editingSurveyId.value = item.id;
      editSurveyModalShown.value = true;
    };
    const onEditSurveyModalFinish = function () {
      editSurveyModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      addSurveyModalShown,
      onAddSurveyModalFinish,

      editingSurveyId,
      editSurveyModalShown,
      onSurveyEdit,
      onEditSurveyModalFinish,
    }
  },
}
</script>

<style lang="less">
.admin-survey {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
